<!--
 * @Description:科室设置弹窗组件
 * @Date: 2023-12-20 18:26:55
-->
<template>
  <el-dialog
    v-if="isdestruction"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="!footer"
    :title="title"
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="beforeClose"
  >
    <div v-loading="loading">
      <div class="table_detail_wrapper">
        <table class="table">
          <thead>
            <tr>
              <th>一级科室</th>
              <th>二级科室</th>
            </tr>
          </thead>
          <tbody v-if="this.tableData.length !== 0">
            <tr v-for="(item, index) in tableData" :key="index">
              <td>
                <el-checkbox
                  :disabled="disabled || item.isImportedPeople"
                  v-model="item.enabled"
                  @change="handleCheckAllChange(item.enabled, index)"
                >
                  {{ item.name }}
                </el-checkbox>
              </td>
              <td>
                <el-checkbox-group
                  :disabled="disabled"
                  v-model="item.checkedDepArr"
                  @change="handleCheckedDeparChange(item, index)"
                >
                  <div class="checkbox-div">
                    <el-checkbox
                      style="display: flex;"
                      :disabled="disabled || cItem.isImportedPeople"
                      v-for="cItem in item.list"
                      :label="cItem.id"
                      :key="cItem.id"
                    >
                      {{ cItem.name }}
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="this.tableData.length == 0" class="tips-d">
          暂无数据
        </div>
      </div>
    </div>

    <span
      v-if="footer"
      style="display: flex; justify-content: center; margin-top: 20px;"
    >
      <el-button type="primary" :loading="btnLoading" @click="confirm">
        保 存
      </el-button>
      <el-button @click="cancellation">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    dialogVisibles: {
      type: Boolean,
      default: false
    },
    control: {
      type: Number
    },
    oldControls: {
      type: Number
    },
    titles: {
      type: String,
      default: '科室设置'
    },
    projectId: {
      type: Number
    },
    footer: {
      type: Boolean,
      default: true
    },
    disableds: {
      type: Boolean,
      default: false
    },
    getAjax: { type: Function },
    saveAjax: { type: Function },
    isImportedPeople: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isdestruction: true,
      btnLoading: false,
      loading: false,
      disabled: this.disableds,
      title: this.titles,
      tableData: [],
      dialogVisible: this.dialogVisibles
    };
  },
  computed: {},
  watch: {},
  methods: {
    cancellation() {
      this.$emit('cancel', this.oldControls);
      this.dialogVisible = false;
      this.comDestruction();
    },
    handleCheckAllChange(enabled, index) {
      if (enabled) {
        this.tableData.forEach((element, i) => {
          if (index == i) {
            element.list.forEach(item => {
              item.enabled = true;
              if (item.enabled) {
                element.checkedDepArr.push(item.id);
              }
            });
          }
        });
      } else {
        this.tableData.forEach((element, i) => {
          if (index == i) {
            element.checkedDepArr = [];
          }
        });
      }
    },
    handleCheckedDeparChange(item, index) {
      this.tableData.forEach((item1, index1) => {
        if (index == index1) {
          item1.enabled = item.checkedDepArr.length == item1.list.length;
        }
      });
    },
    confirm() {
      let query = [];
      this.tableData.forEach(item => {
        query.push(...item.checkedDepArr);
      });
      if (query.length == 0) {
        this.$message({
          type: 'info',
          message: '科室设置必须至少选择一个二级科室！'
        });
        return;
      }
      try {
        let newQuery = new Set(query);
        let params = {
          projectId: this.projectId,
          isDeptLimit: this.control,
          deptIdSeq: Array.from(newQuery).join(',')
        };
        this.btnLoading = true;
        this.saveAjax(params).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功！'
          });
          this.btnLoading = false;
          this.dialogVisible = false;
        });
      } catch (error) {
        this.btnLoading = false;
      }
    },
    handleInitData() {
      try {
        this.loading = true;
        this.getAjax({ projectId: this.projectId }).then(res => {
          this.tableData = res.data.data.map(item => {
            item.checkedDepArr = [];
            if (this.isImportedPeople == 1 && item.enabled) {
              item.isImportedPeople = true;
            }

            item.list.forEach(Citem => {
              if (Citem.enabled) {
                if (this.isImportedPeople == 1 && Citem.enabled) {
                  Citem.isImportedPeople = true;
                }
                item.checkedDepArr.push(Citem.id);
              }
            });
            return item;
          });
          if (this.disableds) {
            this.seeCheckDepartmet();
          }
          this.loading = false;
        });
      } catch (error) {
        this.loading = false;
      }
    },
    seeCheckDepartmet() {
      this.$nextTick(() => {
        let checkDom = document.querySelectorAll('.el-checkbox__label');
        checkDom.forEach(item => {
          if (item.previousSibling.lastChild.checked) {
            item.style.color = '#409EFF';
            item.previousSibling.className =
              'el-checkbox__input is-disabled is-checked';
            item.previousSibling.firstElementChild.style.backgroundColor =
              '#409EFF';
            item.previousSibling.firstElementChild.style.borderColor =
              '#409EFF';
          } else {
            item.style.color = '#606266';
          }
        });
      });
    },
    beforeClose() {
      this.comDestruction();
    },
    comDestruction() {
      this.isdestruction = false;
    }
  },
  created() {
    this.handleInitData();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.table_detail_wrapper {
  max-height: 500px;
  overflow: auto;
  width: 100%;
  border-left: 1px solid #cfcdcd;
  border-right: 1px solid #cfcdcd;
  border-top: 1px solid #cfcdcd;
  border-bottom: 1px solid #cfcdcd;
  .table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    thead {
      text-align: center;
      tr {
        // height: 50px;
        th {
          border-left: 1px solid #cfcdcd;
          border-right: 1px solid #cfcdcd;
          border-bottom: 1px solid #cfcdcd;
          box-sizing: border-box;
          position: sticky;
          font-weight: 400;
          padding: 0;
          width: 200px;
          box-sizing: border-box;
          height: 50px;
          z-index: 999;
          top: -1px;
          background-color: #e6f1ff;
          &:first-child {
            width: 40px !important;
            border-left: none;
          }
          &:last-child {
            border-right: none;
          }
        }
      }
    }

    tbody {
      text-align: center;
      // height: 536px;
      tr {
        td {
          border: 1px solid #cfcdcd;
          &:first-child {
            border-left: none;
          }
          &:last-child {
            border-right: none;
          }
          .checkbox-div {
            width: 100%;
            padding: 10px;
            display: inline-grid;
            grid-template-columns: repeat(5, 1fr);
            grid-auto-flow: dense;
          }
        }

        &:last-child {
          td {
            border-bottom: none;
            border-right: none;
          }
        }
      }
    }
  }
  .tips-d {
    text-align: center;
  }
}
::-webkit-scrollbar {
  display: none;
}
</style>
